module.exports = __webpack_public_path__ + "img/white_arrow.f4e4763c.png";